/**
 * Created with IntelliJ IDEA.
 * User: ShaharA
 * Date: 7/14/13
 * Time: 7:57 AM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/language-settings/LanguageSettingsPageView.tmpl");
    var List = require("ui/list/List");
    var Button = require("ui/button/Button");
    var Marionette = require('marionette');

    var _ = require('underscore');
    var $ = require('jquery');

    var LanguageSelectionPageView = {};

    LE.module("LEManager", function (LEManager, LE) {
        LanguageSelectionPageView = Marionette.ItemView.extend({
            template: template,
            className: "language-selection-page",
            events: {
            },

            vent: null,

            initialize: function (options) {
                LEManager.logger.debug("initializing","LanguageSelectionPageView:initialize",{options: options});
                this.vent = options.vent;
                this.eventPrefix = options.eventPrefix;
                this.protectedLanguage = options.protectedLanguage;

                this.languageNamesTranslated = LE.siteSettings.supportedLanguageSettings.getAllLanguageNamesTranslated();
            },
            ui: {
                defaultLanguage: ".default-language",
                selectedLanguages: ".selected-languages",
                selectedLanguagesCount: ".selected-count",
                emptySelectionContainer: ".empty-selection-container",
                languageFilter: ".language-filter",
                availableLanguages: ".available-languages",
                saveBtn: ".button-save",
                cancelBtn: ".button-cancel"
            },

            uiComponents:{
                defaultLanguage: {// can be only one but since it uses same design, it was decided to use list & collection for the default
                    type: List,
                    options: {
                        container: 'view.ui.defaultLanguage',
                        items: "view._getDefaultLanguage",
                        maxShownItems: 0,
                        hasCheckbox: false,
                        selectable: false,
                        floating: false
                    }
                },
                selectedLanguagesList: {
                    type: List,
                    options: {
                        container: 'view.ui.selectedLanguages',
                        items: "view._getSelectedLanguages",
                        maxShownItems: 0,
                        hasCheckbox: false,
                        selectable: false,
                        floating: false
                    },
                    events: {
                        actionSelect: "onSelectedLanguageClicked",
                        actionRemove: "onSelectedLanguageRemoved"
                    }
                },
                availableLanguagesList: {
                    type: List,
                    options: {
                        container: 'view.ui.availableLanguages',
                        items: "view._getAvailableLanguages",
                        maxShownItems: 0,
                        hasCheckbox: false,
                        selectable: false,
                        floating: false
                    },
                    events: {
                        actionAdd: "onAvailableLanguageClicked"
                    }
                },
                saveBtn:{
                    type:Button,
                    options:{
                        el: 'view.ui.saveBtn',
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.ENABLED
                    },
                    events:{
                        "click":"onSaveButtonClicked"
                    }
                },
                cancelBtn:{
                    type:Button,
                    options:{
                        el: 'view.ui.cancelBtn',
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events:{
                        "click":"onCancel"
                    }
                }
            },

            onRender :function() {
                this._updateSelectionContainer();
                this.listenTo(this, "page:closeButtonClick", this.onCancel);
            },

            _getDefaultLanguage: function() {
                var defaultLanguageCode = LE.siteSettings.supportedLanguageSettings.getDefaultLanguage();

                var langArr = [];
                langArr.push(this._getDefaultLanguageObjectByCode(defaultLanguageCode));
                return langArr;
            },

            _getDefaultLanguageObjectByCode: function(languageCode) {
                return {
                    id: languageCode,
                    value: this.languageNamesTranslated[languageCode],
                    className: "language-item"
                };
            },

            _getSelectedLanguages: function() {
                var defaultLanguageCode = LE.siteSettings.supportedLanguageSettings.getDefaultLanguage();
                var selectedLanguageCodes = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                selectedLanguageCodes = _.without(selectedLanguageCodes, defaultLanguageCode);

                var langArr = _.map(selectedLanguageCodes, function(languageCode) {
                    return this._getSelectedLanguageObjectByCode(languageCode);
                }, this);
                return langArr;
            },

            _getSelectedLanguageObjectByCode: function(languageCode) {
                return {
                    id: languageCode,
                    value: this.languageNamesTranslated[languageCode],
                    className: "language-item",
                    actions: {
                        select: LE.translator.translate("LEManager.manager.languageSettings.page.action.tooltip.action-select"),
                        remove: (this._isProtectedLanguage(languageCode) ? false : LE.translator.translate("LEManager.manager.languageSettings.page.action.tooltip.action-remove"))
                    }
                };
            },

            _getAvailableLanguages: function() {
                var defaultLanguageCode = LE.siteSettings.supportedLanguageSettings.getDefaultLanguage();
                var supportedLanguageCodes = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                var availableLanguageCodes = _.difference(LE.siteSettings.supportedLanguageSettings.getAllLanguageCodes(), supportedLanguageCodes);

                var langArr = _.map(availableLanguageCodes, function(languageCode) {
                    return this._getAvailableLanguageObjectByCode(languageCode);
                }, this);
                return langArr;
            },

            _getAvailableLanguageObjectByCode: function(languageCode) {
                return {
                    id: languageCode,
                    value: this.languageNamesTranslated[languageCode],
                    className: "language-item",
                    actions: {
                        add: LE.translator.translate("LEManager.manager.languageSettings.page.action.tooltip.action-add")
                    }
                };
            },

            _isProtectedLanguage: function (code) {
                return (this.protectedLanguage === code);
            },

            _updateSelectionContainer: function() {
                // decide which selection container to show
                $(this.ui.emptySelectionContainer).toggle(_.isEmpty(this.uiComponents.selectedLanguagesList.getItems()));
                $(this.ui.selectedLanguages).toggle(!_.isEmpty(this.uiComponents.selectedLanguagesList.getItems()));

                // set selected languages count
                $(this.ui.selectedLanguagesCount).text(this.uiComponents.selectedLanguagesList.getItems().length);
            },

            onSelectedLanguageClicked: function (componentId, eventName, obj) {
                var languageCode = obj.id;
                var currentDefaultLanguageCode = this.uiComponents.defaultLanguage.getItems()[0].id;

                this.uiComponents.selectedLanguagesList.addItem(this._getSelectedLanguageObjectByCode(currentDefaultLanguageCode));
                this.uiComponents.selectedLanguagesList.removeItem(languageCode);

                this.uiComponents.defaultLanguage.addItem(this._getDefaultLanguageObjectByCode(languageCode));
                this.uiComponents.defaultLanguage.removeItem(currentDefaultLanguageCode);
            },

            onSelectedLanguageRemoved: function (componentId, eventName, obj) {
                var languageCode = obj.id;
                this.uiComponents.availableLanguagesList.addItem(this._getAvailableLanguageObjectByCode(languageCode));
                this.uiComponents.selectedLanguagesList.removeItem(languageCode);
                this._updateSelectionContainer();
            },

            onAvailableLanguageClicked: function (componentId, eventName, obj) {
                var languageCode = obj.id;
                this.uiComponents.availableLanguagesList.removeItem(languageCode);
                this.uiComponents.selectedLanguagesList.addItem(this._getSelectedLanguageObjectByCode(languageCode));
                this._updateSelectionContainer();
            },

            onSaveButtonClicked: function(){
                LEManager.logger.info("Saving language settings data" , "LanguageSelectionPageView:onSaveButtonClicked");
                var defaultLanguageModel = this.uiComponents.defaultLanguage.getItems()[0];
                if (_.has(defaultLanguageModel,"id")) {
                    var defaultLanguageCode = defaultLanguageModel.id;
                    var selectedLanguageCodes = _.pluck(this.uiComponents.selectedLanguagesList.getItems(), "id");
                    // add default to the selected list
                    selectedLanguageCodes.push(defaultLanguageCode);

                    // trigger Save event to Controller
                    this.vent.trigger(this.eventPrefix + ":Save", defaultLanguageCode, selectedLanguageCodes);
                }
            },

            /**
             * Cancel event
             */
            onCancel: function () {
                LEManager.logger.debug("at onCancel ","LanguageSelectionPageView:onCancel");
                this.vent.trigger(this.eventPrefix + ":Close");
            },

            onBeforeClose : function () {
                this.stopListening();

                if (this.uiComponents.saveBtn) {
                    this.uiComponents.saveBtn.close();
                }

                if (this.uiComponents.cancelBtn){
                    this.uiComponents.cancelBtn.close();
                }
            },
            /**
             * Close event
             */
            onClose: function () {
                LEManager.logger.debug("closing","LanguageSelectionPageView:onClose");
            }

        });

    });

    return LanguageSelectionPageView;
});
